import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolder, faTimes, faCheck, faPalette } from '@fortawesome/free-solid-svg-icons';
import './CreateFolderModal.css';

const colors = [
  '#722ed1', // Purple
  '#52c41a', // Green
  '#fa8c16', // Orange
  '#f5222d', // Red
  '#9254de', // Light Purple
  '#13c2c2', // Cyan
  '#eb2f96', // Magenta
  '#2f54eb', // Blue
];

const CreateFolderModal = ({ isOpen, onClose, onCreate }) => {
  const [folderName, setFolderName] = useState('');
  const [description, setDescription] = useState('');
  const [selectedColor, setSelectedColor] = useState(colors[0]);

  const isFormValid = folderName.trim() !== '';

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onCreate({ name: folderName, description, color: selectedColor });
    setFolderName('');
    setDescription('');
    setSelectedColor(colors[0]);
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="create-folder-modal">
        <div className="modal-header">
          <div className="header-left">
            <div className="header-icon-badge">
                <FontAwesomeIcon icon={faFolder} />
            </div>
            <div className="header-text">
                <h2>Create New Folder</h2>
                <p>Organize your files with a custom folder</p>
            </div>
          </div>
          <button className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        
        <div className="modal-hero">
           <div className="hero-icon-container">
               <div className="hero-icon-bg" style={{ background: `linear-gradient(135deg, ${selectedColor} 0%, ${selectedColor}dd 100%)` }}>
                  <FontAwesomeIcon icon={faFolder} className="hero-icon" />
               </div>
           </div>
           <h3>New Folder</h3>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Folder Name *</label>
            <input 
              type="text" 
              placeholder="Enter folder name..." 
              value={folderName} 
              onChange={(e) => setFolderName(e.target.value)}
              required 
            />
          </div>
          <div className="form-group">
            <label>Description (Optional)</label>
            <textarea 
              placeholder="Add a description for this folder..." 
              value={description} 
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label><FontAwesomeIcon icon={faPalette} className="palette-icon" /> Choose Color</label>
            <div className="color-picker">
              {colors.map((color, index) => (
                <div 
                  key={index} 
                  className={`color-circle ${selectedColor === color ? 'selected' : ''}`}
                  style={{ backgroundColor: color }}
                  onClick={() => setSelectedColor(color)}
                >
                  {selectedColor === color && <FontAwesomeIcon icon={faCheck} className="check-icon" />}
                </div>
              ))}
            </div>
          </div>
          
          <div className="modal-actions">
            <button type="button" className="cancel-button" onClick={onClose}>Cancel</button>
            <button 
              type="submit" 
              className={`create-button ${isFormValid ? 'active' : ''}`}
              disabled={!isFormValid}
            >
              Create Folder
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateFolderModal;

